import { useState, useEffect } from "react";
import { useContentsContext } from "./useContentsContext.hook";
import { useContents } from "./useContents.hook";

const useContentDialogMaintenance = ({ school, setDialog }) => {
  const {
    content,
    allCategories,
    allContributing_factors,
    allFocusAreas,
    allTags,
  } = useContentsContext();
  const { getContentsx, create: CreateHook, update: UpdateHook } = useContents(
    {}
  );

  const [
    filteredContributingFactors,
    setFilteredContributingFactors,
  ] = useState([]);
  const [filteredCategories, setfilteredCategories] = useState([]);
  const [filteredFocusAreas, setFilteredFocusAreas] = useState([]);
  const [filteredTags, setFilteredTags] = useState([]);
  const [loading, setLoading] = useState(false);

  const moods = [
    { key: 1, name: "Great" },
    { key: 2, name: "Alright" },
    { key: 3, name: "Not Great" },
  ];

  const filterCategories = (opt = undefined) => {
    if (!Array.isArray(allCategories) || allCategories.length === 0) {
      setfilteredCategories([]);
      return;
    }

    const flag = opt !== undefined ? opt : content?.is_pro_athlete ?? false;
    const filtered = allCategories.filter((c) => c.is_pro_athlete === flag);

    setfilteredCategories(filtered);
  };
  const filterContributingFactors = (opt = undefined) => {
    if (
      !Array.isArray(allContributing_factors) ||
      allContributing_factors.length === 0
    ) {
      setFilteredContributingFactors([]);
      return;
    }

    const flag =
      opt !== undefined ? opt : Boolean(content?.isContentProAthlete);
    const [min, max] = flag ? [4, 7] : [1, 4];

    setFilteredContributingFactors(
      allContributing_factors.filter(
        (item) => item.value >= min && item.value <= max
      )
    );
  };
  const filterFocusAreas = (opt = undefined) => {
    if (!Array.isArray(allFocusAreas) || allFocusAreas.length === 0) {
      setFilteredFocusAreas([]);
      return;
    }

    const showPro =
      opt !== undefined ? Boolean(opt) : Boolean(content?.is_pro_athlete);

    const newFocusAreas = allFocusAreas.filter(
      (t) => Boolean(t?.is_pro_athlete) === showPro
    );

    setFilteredFocusAreas(newFocusAreas);
  };
  const filterTags = (opt = undefined) => {
    if (!Array.isArray(allTags) || allTags.length === 0) {
      setFilteredTags([]);
      return;
    }

    const flag = opt !== undefined ? opt : Boolean(content?.is_pro_athlete);

    let newTags = allTags.filter(
      (t) => Boolean(t?.is_pro_athlete) === Boolean(flag)
    );

    const routineTag = allTags.find((t) => t?.id === 1);
    if (routineTag && !newTags.some((t) => t?.id === 1)) {
      newTags = [routineTag, ...newTags];
    }

    if (Array.isArray(allTags)) {
      setFilteredTags(newTags);
    } else if (
      allTags &&
      typeof allTags === "object" &&
      Array.isArray(allTags.data)
    ) {
      setFilteredTags({ ...allTags, data: newTags });
    } else {
      setFilteredTags(newTags);
    }
  };

  const is_disabled = (values) => {
    if (values.content_type === "tip")
      if (
        values.content === undefined ||
        !values.name ||
        !values.content_type ||
        !values.description_content ||
        values.moods_id.length === 0 ||
        values.contributing_factors_id.length === 0
      )
        return true;
      else return false;
    else if (
      (values.content === undefined
        ? true
        : !content.id
        ? false
        : values.resource_url_slides.length === 0) ||
      !values.name ||
      !values.content_type ||
      !values.duration ||
      !values.author_name ||
      !values.content_partner ||
      !values.description ||
      values.categories_id.length === 0
    )
      return true;
    else return false;
  };

  const create = async (values) => {
    try {
      await CreateHook({
        ...values,
        description_content: values.description_content,
      });
      setLoading(false);
      setDialog("close");
      getContentsx();
    } catch (error) {
      setLoading(false);
    }
  };

  const update = async (values) => {
    try {
      const payload = {
        author_name: values.author_name,
        categories_id: values.categories_id,
        content: values.content,
        content_partner: values.content_partner || "",
        content_type: values.content_type,
        contributing_factors_id: values.contributing_factors_id,
        description: values.description,
        description_content: values.description_content,
        is_pro_athlete: values.is_pro_athlete,
        duration: values.duration,
        focus_areas_ids: values.focus_areas_ids,
        tags_ids: values.tags_ids,
        image: values.image || null,
        logo: values.logo || null,
        moods_id: values.moods_id,
        name: values.name,
        is_tip: values.is_tip,
      };
      await UpdateHook({ ...payload, content_id: content.id }, content.id);
      setLoading(false);
      setDialog("close");
      getContentsx();
    } catch (error) {
      setLoading(false);
    }
  };

  const permitedFiles = (type) => {
    if (type === "pdf") return "application/pdf";
    if (type === "audio") return "audio/*";
    if (type === "video") return "video/*";
    if (type === "image") return "image/*";
    if (type === "tip") return "image/*, .gif, .json";
    if (type === "document")
      return "application/pdf,application/msword, .doc, .docx, .ppt, .pptx, .gdoc, .gdocs, .xls, .xlsx, .csv, .txt";
    else return "*";
  };

  useEffect(() => {
    filterCategories();
    filterTags();
    filterFocusAreas();
    filterContributingFactors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    allContributing_factors,
    allCategories,
    allFocusAreas,
    allTags,
    content.is_pro_athlete,
    // content.isContentProAthlete,
    // content.contributing_factors,
  ]);

  useEffect(() => {
    filterCategories();
    filterTags();
    filterFocusAreas();
    filterContributingFactors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    content,
    filteredCategories,
    moods,
    filteredContributingFactors,
    filteredFocusAreas,
    filteredTags,
    permitedFiles,
    filterCategories,
    filterTags,
    filterFocusAreas,
    filterContributingFactors,
    is_disabled,
    create,
    update,
    loading,
    setLoading,
    getContentsx,
  };
};

export default useContentDialogMaintenance;
